import $ from 'jquery';
import "select2"

const RoadWorksSearchField = () => {

    // Initialise select2 library on select dropdown
    $("#road-works__search-field").select2({
        placeholder: "Select a road",
        "language": {
        "noResults": function(){
                return "No programmed work for this road";
            }
        },
        width: '100%'
        
    }).prop("disabled", false);

    // Add / Remove placeholder text on search input
    $("#road-works__search-field").on("select2:open", function() {
        $(".select2-search--dropdown .select2-search__field").attr("placeholder", "Type here to filter list e.g. Tapuaeroa Road");
    });

    $("#road-works__search-field").on("select2:close", function() {
        $(".select2-search--dropdown .select2-search__field").attr("placeholder", null);
    });

}

export default RoadWorksSearchField;